<div class="hub-help-dialog-container">
    <div class="hub-help-header">
        <h4>Get Hub Help and Explore our 2030 Goals</h4>
    </div>

    <div class="hub-help-body">
        <div class="hub-help-row">
            <div class="help-icon">
                <img src="/assets/images/icons/help-icon.png">
            </div>
            <div div class="help-description">
                <div class="help-title">Get Help and Connect</div>
                <div class="help-content">
                    Explore
                    <a href="https://thenatureconservancy462.sharepoint.com/sites/Conservation/SitePages/The-Hub.aspx?csf=1&web=1&e=RK2nnc" target="_blank">
                        The Conservation Hub Connect Page
                    </a>
                    or email <a href="mailto:conservationdatahelp@tnc.org?subject=Requesting Hub Assistance">conservationdatahelp@tnc.org</a> with questions.
                </div>
            </div>
        </div>

        <div class="hub-help-row">
            <div class="help-icon">
                <img src="/assets/images/icons/target.png">
            </div>
            <div div class="help-description">
                <div class="help-title">Explore our 2030 Goals</div>
                <div class="help-content">
                    Visit the
                    <a href=" https://thenatureconservancy462.sharepoint.com/sites/Conservation/SitePages/Shared-Conservation-Agenda-%26-2030-Goals.aspx?csf=1&web=1&e=Q2YFP6"
                        target="_blank">
                        2030 Goals Connect Page
                    </a> to learn more about our 2030 Goals.
                </div>
            </div>
        </div>

        <div class="hub-help-row">
            <div class="help-icon">
                <img src="/assets/images/icons/shield.png">
            </div>
            <div div class="help-description">
                <div class="help-title">Internal Data Policies</div>
                <div class="help-content">
                    <a href="https://thenatureconservancy462.sharepoint.com/sites/Conservation/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2FConservation%2FShared%20Documents%2FHub%20Guidance%20%2D%20Sharing%20with%20External%20Audiences%2Epdf&parent=%2Fsites%2FConservation%2FShared%20Documents&p=true&ga=1"
                        target="_blank">Hub Data Best Practices and SOPs</a>
                </div>
            </div>
        </div>

    </div>

    <div class="hub-help-footer">
        <button (click)="closeDialog()">Close</button>
    </div>
</div>
